import { FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import { baseColors, Button, Chevron, ChevronDirection } from '@fairhq/common'
import { LinkButton } from 'styled'

import { ReactComponent as PreviousIcon } from './assets/previous.svg'

const AreaFooterContainer = styled.div`
  width: 100%;
  background-color: ${baseColors.backgroundCard};
  border-top: 1px solid ${baseColors.borderBackground};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`

const Controls = styled.div`
  max-width: 800px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  flex-flow: row wrap;
  height: 100px;
  min-height: 100px;
  margin: auto !important;

  .rs-btn {
    font-size: 14px;
  }
`

const PreviousSection = styled.div`
  display: flex;
  align-content: center;
  gap: 12px;

  .rs-btn:first-of-type {
    svg {
      margin-right: 8px;
    }
  }
`

interface AreaFooterProps {
  disabledNext?: boolean
  disabledPrevious?: boolean
  loadingNext?: boolean
  onNext?: () => void
  onPrevious?: () => void
  onSkip?: () => void
  hasNext?: boolean
  skipped?: boolean
}

export const AreaFooter: FunctionComponent<AreaFooterProps> = ({
  disabledNext,
  disabledPrevious,
  loadingNext,
  onNext,
  onPrevious,
  onSkip,
  hasNext,
  skipped,
}) => {
  const { t } = useTranslation()
  return (
    <AreaFooterContainer>
      <Controls>
        <PreviousSection>
          {onPrevious ? (
            <LinkButton onClick={onPrevious} disabled={disabledPrevious}>
              <PreviousIcon />
              <span>{t('areas.label.previous')}</span>
            </LinkButton>
          ) : undefined}
          {onSkip ? (
            <LinkButton onClick={onSkip}>
              {skipped
                ? t('areas.label.skipAgain')
                : t('areas.label.skipQuestion')}
            </LinkButton>
          ) : undefined}
        </PreviousSection>
        {onNext ? (
          <Button
            onClick={onNext}
            disabled={disabledNext || loadingNext}
            loading={loadingNext}
            iconRight={
              hasNext ? (
                <Chevron direction={ChevronDirection.RIGHT} />
              ) : undefined
            }
          >
            <span>
              {hasNext ? t('areas.label.next') : t('areas.label.finish')}
            </span>
          </Button>
        ) : undefined}
      </Controls>
    </AreaFooterContainer>
  )
}
